import React from 'react';
import { Progress } from 'antd';
import Label from '../form/Label/Label';
import { FlexContainer } from '../Containers/FlexContainer/FlexContainer';
import './ProgressAccountMix.scss';
import classnames from 'classnames';

const PotentialDialFormat = props => {
  const { totalCount, percentClass, dti } = props;

  const percentClasses = classnames(percentClass, 'system_neutral_n250_text ', {
    'H5-gray050': totalCount === '?',
  });
  const dtiClasses = classnames('Overline', {
    poof: !dti,
  });

  return (
    <FlexContainer className="flex-column align-items-center">
      <Label className={percentClasses} tabIndex="-1">
        {totalCount}
      </Label>
      <Label className={dtiClasses} tabIndex="-1">
        DTI
      </Label>
    </FlexContainer>
  );
};

const ProgressAccountMix = props => {
  const { success, percent, strokeColor, percentClass, dti } = props;

  const width = {
    large: 142,
    medium: 136,
    small: 72,
    ocfMedium: 124,
  };

  const strokeColorClass = success ? strokeColor : '';
  const totalSuccess = success ? `${success}%` : '?';

  return (
    <div className={'ProgressAccountMix yellowProgress'}>
      <Progress
        type="circle"
        percent={percent}
        success={{ percent: success || '' }}
        width={props?.size ? width[props?.size] : width['small']}
        strokeColor={strokeColorClass}
        aria-label={'progressbar'}
        format={() => (
          <PotentialDialFormat
            percentClass={percentClass}
            totalCount={totalSuccess}
            dti={dti}
          />
        )}
      />
    </div>
  );
};

export default ProgressAccountMix;
